/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CLASSROOM_MEMBERSHIP_LEVEL = "ADMIN" | "BANNED" | "CREATOR" | "MEMBER" | "PENDING" | "%future added value";
export type ClassroomViewer_viewer = {
    readonly user: {
        readonly id: string;
        readonly isAdmin: boolean;
        readonly classroomMemberships: ReadonlyArray<{
            readonly level: CLASSROOM_MEMBERSHIP_LEVEL;
            readonly classroom: {
                readonly id: string;
            };
        } | null>;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"ClassroomActions_viewer">;
    readonly " $refType": "ClassroomViewer_viewer";
};
export type ClassroomViewer_viewer$data = ClassroomViewer_viewer;
export type ClassroomViewer_viewer$key = {
    readonly " $data"?: ClassroomViewer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ClassroomViewer_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ClassroomViewer_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "user",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isAdmin",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "classroomMemberships",
          "storageKey": null,
          "args": null,
          "concreteType": "ClassroomMembership",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "level",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "classroom",
              "storageKey": null,
              "args": null,
              "concreteType": "Classroom",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ClassroomActions_viewer",
      "args": null
    }
  ]
};
})();
(node as any).hash = '877be19f3c664f2ed1b0de222ff4aa5d';
export default node;
